/**
 * PDP dependent options assist.
 *
 * product-variant-options.liquid only renders child-level values that EXIST
 * under the selected parent values. When the shopper changes a parent, the
 * previously selected child value may not be rendered at all in the
 * server-re-rendered picker — leaving that level with no checked input and the
 * product form pointing at a nonexistent combination ("Unavailable").
 *
 * After every picker render, any level without a checked input gets its first
 * rendered value clicked, which triggers the normal Dawn flow (section fetch →
 * re-render → valid variant resolved).
 */
(function () {
  'use strict';

  // Consecutive auto-clicks without convergence — hard stop so a server that
  // keeps answering with an orphan level (or 5xx churn) can never produce an
  // infinite click → fetch → re-render loop.
  var attempts = 0;
  var MAX_ATTEMPTS = 2;

  function fixOrphanLevels() {
    if (attempts >= MAX_ATTEMPTS) return;
    var clicked = false;
    var selectsList = document.querySelectorAll('variant-selects');
    for (var s = 0; s < selectsList.length && !clicked; s++) {
      var selects = selectsList[s];
      // Skip the old node HTMLUpdateUtility keeps (display:none) for 500ms
      // during the view transition — only the live picker counts.
      if (selects.style.display === 'none') continue;
      var fieldsets = selects.querySelectorAll('fieldset.product-form__input');
      for (var i = 0; i < fieldsets.length; i++) {
        var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
        if (!checked) {
          var first = fieldsets[i].querySelector('input[type="radio"]');
          if (first) {
            attempts++;
            clicked = true;
            first.click(); // re-renders the picker; next pass re-validates
            break;
          }
        }
      }
    }
    if (!clicked) attempts = 0; // converged — reset for the next user change
  }

  // When no variant matches the selection, buy-buttons.liquid renders the
  // submit button enabled with data-needs-selection="{level name}" and the
  // text "Pick a {level}". Dawn's toggleSubmitButton then resets the label to
  // "Add to cart" after each section render — re-assert ours.
  function updateSubmitButton() {
    document.querySelectorAll('button[id^="ProductSubmitButton-"][data-needs-selection]').forEach(function (btn) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      var span = btn.querySelector('span');
      var label = 'Pick a ' + btn.getAttribute('data-needs-selection');
      if (span && span.textContent.trim() !== label) span.textContent = label;
    });
  }

  // Clicking the button while a level is unpicked: no dead button, no bogus
  // cart POST — surface the existing floating toast instead.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('button[id^="ProductSubmitButton-"][data-needs-selection]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var message = 'Please pick a ' + btn.getAttribute('data-needs-selection') + ' to continue.';
      if (window.showInlineFormMessage) {
        window.showInlineFormMessage({ message: message, type: 'error' });
      } else {
        alert(message);
      }
    },
    true
  );

  function init() {
    fixOrphanLevels();
    updateSubmitButton();
    // PUB_SUB_EVENTS/subscribe are top-level consts/functions from
    // constants.js/pubsub.js — NOT window properties; probe with typeof.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // The picker swap may run inside a view transition; give it a beat
        // before inspecting the new inputs.
        requestAnimationFrame(function () {
          setTimeout(function () {
            fixOrphanLevels();
            updateSubmitButton();
          }, 50);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
